import { z } from 'zod'

import { DateZod } from '../../common'

export const AssigmentExecutionZod = z.object({
  teamId: z.string(),
  transportRequestId: z.string(),
  status: z.enum(['pending', 'executed', 'disabled', 'dryRun']),
  message: z.string().optional(),
  deleteAt: DateZod.optional(),
})
